import { Box } from '@frontend/legacy-components';

import NavItems from './NavItems';

const DesktopTabs = () => {
  return (
    <Box
      display={{
        base: 'none',
        tablet: 'flex',
      }}
      height="100%"
    >
      <NavItems iconTextProps={{ fontSize: '10px' }} />
    </Box>
  );
};

export default DesktopTabs;
